import { render } from "./Participants.vue?vue&type=template&id=19af9868&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"

import "./Participants.vue?vue&type=style&index=0&id=19af9868&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19af9868"]])

export default __exports__